// ReSharper disable once UnusedLocalImport
import React, { Component, ChangeEvent, FormEvent } from "react";
import {
    Button, Container, Row, ListGroup, ListGroupItem, Badge, Card, CardBody, CardTitle, CardSubtitle, CardText,
    ListGroupItemHeading, ListGroupItemText, Col, Form, FormGroup, Label, Input, FormText, Tooltip,
    Popover, PopoverHeader, PopoverBody, Dropdown, DropdownToggle, DropdownMenu, DropdownItem 
} from "reactstrap";
import ReactBootstrapSlider, { SliderChangeEvent } from 'react-bootstrap-slider';
import {
    Options, Option, OscillatorType, OperatingVoltage, Packaging, RfOutputType,
    rfOutputTypes, oscillatorTypes, operatingVoltages, packagings
} from "../models/options";
import PartResult from "./partResult";
import "./partBuilder.css"
import "../../node_modules/react-bootstrap-slider/src/css/bootstrap-slider.min.css"

enum Popovers {
    None,
    RfOutputType,
    OcType,
    OpVoltage,
    Frequency,
    Packaging
}

type State = {
    rfOutputType: RfOutputType,
    oscillatorType: OscillatorType,
    operatingVoltage: OperatingVoltage,
    frequency: Number,
    packaging: Packaging,
    dropdownOpen: boolean,
    popoverOpen: Popovers;
}

export class PartBuilder extends Component {
    state: State = {
        rfOutputType: RfOutputType.NA,
        oscillatorType: OscillatorType.NA,
        operatingVoltage: OperatingVoltage.NA,
        frequency: 500,
        dropdownOpen: false,
        packaging: Packaging.NA,
        popoverOpen: Popovers.None
    }

    handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
        const element = e.target;
        if (element) {
            const update = {
                [element.name]: Number(element.value)
            };
            this.setState(update);
            this.toggle(Popovers.None)
        }
    }

    handleSubmit = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
    }

    createCheckBoxes = (name: string, options: Options, valueInState: Number) => {
        return Object.keys(options).map((key, index) => {
            const item = Number(key);
            const value = options[key as any];

            let className = value.title.length === 0 ? "hidden" : "";
            if (valueInState === item) {
                className += " checked";
            }

            return (
                <FormGroup key={`${name}-${index}`} check className={className}>
                    <Label check>
                        <Input type="radio" name={name} value={item} checked={valueInState === item} onChange={this.handleInputChange} />
                        {value.title}
                    </Label>
                </FormGroup>
            );
        });
    }

    changeFrequencyValue = (event: any) => {
        console.log(event.target.value);
        this.setState({
            frequency: event.target.value
        });
    }

    toggle = (popover: Popovers) => {
        this.setState({
            popoverOpen: popover
        });
    }
    
    render() {
        const rfOutputTypeBoxes = this.createCheckBoxes("rfOutputType", rfOutputTypes, this.state.rfOutputType);
        const oscillatorTypeBoxes = this.createCheckBoxes("oscillatorType", oscillatorTypes, this.state.oscillatorType);
        const operatingVoltageBoxes = this.createCheckBoxes("operatingVoltage", operatingVoltages, this.state.operatingVoltage);
        const packagingBoxes = this.createCheckBoxes("packaging", packagings, this.state.packaging);

        return (
            <div className="pb-layout">
                <PartResult frequency={this.state.frequency} operatingVoltage={this.state.operatingVoltage} oscillatorType={this.state.oscillatorType}
                    packaging={this.state.packaging} rfOutputType={this.state.rfOutputType} />
                <Form onSubmit={this.handleSubmit} className="pb-form">
                    <FormGroup id="rfinput" tag="fieldset" onClick={() => this.toggle(Popovers.RfOutputType)}>
                        <Dropdown isOpen={this.state.popoverOpen === Popovers.RfOutputType} toggle={() => this.toggle(Popovers.None)}>
                            <DropdownToggle caret>
                            </DropdownToggle>
                            <DropdownMenu>
                            <DropdownItem header>Please select the desired Output</DropdownItem>
                                {rfOutputTypeBoxes}
                            </DropdownMenu>
                        </Dropdown>
                    </FormGroup>

                    <FormGroup id="oscinput" tag="fieldset" onClick={() => this.toggle(Popovers.OcType)}>
                        <Dropdown isOpen={this.state.popoverOpen === Popovers.OcType} target="octype-toogle" toggle={() => this.toggle(Popovers.None)}>
                            <DropdownToggle caret>
                            </DropdownToggle>
                            <DropdownMenu>
                            <DropdownItem header>Please select a part type</DropdownItem>
                            {oscillatorTypeBoxes}
                            </DropdownMenu>
                        </Dropdown>
                    </FormGroup>

                    <FormGroup id="opinput" tag="fieldset" onClick={() => this.toggle(Popovers.OpVoltage)}>
                        <Dropdown isOpen={this.state.popoverOpen === Popovers.OpVoltage} target="opvoltage-toogle" toggle={() => this.toggle(Popovers.None)}>
                            <DropdownToggle caret>
                            </DropdownToggle>
                            <DropdownMenu>
                            <DropdownItem header>Please select your desired Operating Voltage</DropdownItem>
                            {operatingVoltageBoxes}
                            </DropdownMenu>
                        </Dropdown>
                    </FormGroup>

                    <FormGroup id="mhzinput" tag="fieldset" onClick={() => this.toggle(Popovers.Frequency)}>
                        <Dropdown isOpen={this.state.popoverOpen === Popovers.Frequency} target="frequency-toogle" toggle={() => this.toggle(Popovers.None)}>
                            <DropdownToggle caret>
                            </DropdownToggle>
                            <DropdownMenu>
                            <DropdownItem header>Please use the slider to select your Resonant Frequency in MHz</DropdownItem>
                            <ReactBootstrapSlider
                                    ticks = {[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]}
                                    ticks_labels = {["100MHz", "", "", "", "", "", "", "", "", "1000MHz" ]}
                                    value={this.state.frequency}
                                    change={this.changeFrequencyValue}
                                    step={50}
                                    max={1000}
                                    min={100}
                                    orientation="horizontal" />
                            </DropdownMenu>
                        </Dropdown>
                    </FormGroup>

                    <FormGroup id="packageinput" tag="fieldset" onClick={() => this.toggle(Popovers.Packaging)}>
                        <Dropdown isOpen={this.state.popoverOpen === Popovers.Packaging} target="packaging-toogle" toggle={() => this.toggle(Popovers.None)}>
                            <DropdownToggle caret>
                            </DropdownToggle>
                            <DropdownMenu>
                            <DropdownItem header>Please indicate if you're looking for Bulk or Tape & Reel packaging</DropdownItem>
                            {packagingBoxes}
                            </DropdownMenu>
                        </Dropdown>
                    </FormGroup>
                  
                </Form>

            </div>
        );
    }
}